import { Feature, InjectorService, ToolbarService } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { reaction } from 'mobx';

@Feature()
export class ChangeBgFeature extends BaseToolbarFeature {
    id = config.id;
    public toolbarService;
    constructor() {
        super();
        this.toolbarService = InjectorService.get(ToolbarService);
        this.initReaction();
    }

    private initReaction = () => {
        reaction(() => this.getAppService().editableServiceLayer?.rightSideBarManager?.isPropertyEditorShown, () => {
            this.toolbarService.$forceUpdate();
        });
    };
}
